module.exports = __webpack_public_path__ + "img/arrowtriangle-compact-down_fill.e248fab7.svg";